import {Component, OnInit} from '@angular/core';
import {ApiFlowService} from "../../../../data/services/api/flow/api-flow.service";
import {IFlow, IFlowByStages} from "../../../../data/interfaces/iflow.interface";
import {ActivatedRoute, Route, Router} from "@angular/router";
import {ApiExpressLeagueService} from "../data/services/api/api-express-league.service";
import {AuthService} from "../../../../data/services/modules/auth/auth.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LoaderService} from "../data/services/page/loader.service";
import {MessageService} from "primeng/api";
import {ApiCanvassingService} from "../data/services/api/api-canvassing.service";

@Component({
  selector: 'app-verify-information',
  templateUrl: './verify-information.component.html',
  styleUrls: ['./verify-information.component.scss'],
  providers: [MessageService]
})
export class VerifyInformationComponent implements OnInit {
  data!: IFlowByStages
  titleSection = 'CRÉDITO DE NÓMINA'
  backRoute = '/'
  screenVerificationList = true
  currentScreenType = 'FORM'
  currentScreenData!: IFlow
  stepProcess = 'INIT'
  session = ''
  entity!: FormGroup
  codeSent = false
  isPhoneVerified: boolean = false;
  timer = 120
  private timerInterval!: any;
  canvassingOptions: { id: string; name: string }[] = [];
  token = ''
  constructor(
    private flowService: ApiFlowService,
    private activatedRoute: ActivatedRoute,
    private expressLeagueService: ApiExpressLeagueService,
    private canvassingService: ApiCanvassingService,
    private authService: AuthService,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private messageService: MessageService,
    private router: Router,
  ) {
    this.createForm()
  }


  createForm() {
    this.entity = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      secondName: [''],
      fatherLastName: ['', [Validators.required, Validators.minLength(2)]],
      motherLastName: ['', [Validators.required, Validators.minLength(2)]],
      antiquity: ['', [Validators.required,Validators.minLength(2)]],
      position: ['', [Validators.required, Validators.minLength(2)]],
      canvassingId: [null, [Validators.required]],
      rfc: ['', [Validators.required, Validators.pattern(/^[A-Z]{4}[0-9]{2}[0-1][0-9][0-3][0-9][0-9A-Z]{3}$/)]],
      emailAddress: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9_.+-]*[a-zA-Z][a-zA-Z0-9_.+-]*@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/)]],
      phoneNumber: ['',  [Validators.required, Validators.pattern(/^\d{10}$/)]],
      code: ['']
    });
  }

  ngOnInit() {
    this.getQueryParams()
    this.loadCanvassingOptions();
  }

  loadCanvassingOptions() {
    this.canvassingService.getAllCanvassing().subscribe((res) => {
      this.canvassingOptions = res.data.map((c: any, index: number) => ({
        id: c._id,
        name: `${index + 1} - ${c.firstName} ${c.lastName}`
      }));
    });
  }

  startTimer() {
    this.clearTimer(); // Asegura que no haya otro timer en marcha
    this.timer = 120;
    console.log("start")
    this.timerInterval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--; // Decrementa en 1 cada segundo
      } else {
        this.clearTimer(); // Limpia el intervalo cuando llega a 0
      }
    }, 1000);
  }

  clearTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  getFormattedTimer(): string {
    const minutes = Math.floor(this.timer / 60);
    const seconds = this.timer % 60;
    return `${this.padTime(minutes)}:${this.padTime(seconds)}`;
  }

  private padTime(time: number): string {
    return time < 10 ? `0${time}` : `${time}`;
  }




  getQueryParams() {
    console.log(this.authService.getToken)
    if (this.authService.getToken !== '') {
      this.stepProcess = 'PROCESS'
      this.getFlow()
    } else {
      this.activatedRoute.queryParams.subscribe(params => {
        console.log(params)
        const session = params['session']; // Cambia 'exampleParam' por el nombre de tu parámetro.
        if (session || this.authService.getToken !== '') {
          this.session = session
          this.expressLeagueService.getExpressLeague({session}).subscribe(r => {
            console.log(r)
            if (r.data) {
              this.authService.updateUserLocalData(r.data)
              this.router.navigate([], {queryParams: {}})
              this.stepProcess = 'INIT'
            }
          })
        } else {
          this.stepProcess = 'INIT'
        }
      });
    }
  }

  sendSMS() {
    this.loaderService.showSpinner()
    this.expressLeagueService.sendSms(this.entity.value).subscribe(r => {
      this.messageService.add({ severity: r.error ? 'error': 'success', summary: r.error ? 'Error': 'Exitoso', detail: r.msg, life: 10000});
      if (!r.error) {
        this.codeSent = true
        this.startTimer()
      }
      this.loaderService.hideSpinner()
    })
  }

  continue() {
    console.log(this.authService.getToken, "tooooken")
    console.log('[DEBUG] Valores ANTES de verificación:', {
      token: this.authService.getToken,
      isPhoneVerified: this.isPhoneVerified
    });
    if (this.authService.getToken !== '') {
      this.stepProcess = 'PROCESS'
      this.getFlow()
    } else if (this.stepProcess === 'INIT' && this.authService.getToken === '') {
      this.stepProcess = 'RFC'
    }else {
      this.loaderService.showSpinner()
      this.expressLeagueService.createExpressLeague({...this.entity.value}).subscribe(r => {
        if (!r.error) {

          console.log("telefono:", this.isPhoneVerified)
          if (r.data && r.data.token) {
           this.token = r.data.token
            this.isPhoneVerified = true
          } else {
            this.messageService.add({ severity: 'success', summary: 'Exitoso', detail: r.msg, life: 10000});
          }
        } else {
          this.messageService.add({ severity: r.error ? 'error': 'success', summary: r.error ? 'Error': 'Exitoso', detail: r.msg, life: 10000});
        }
        this.loaderService.hideSpinner()
      })
    }
  }

  closeSession() {
    this.authService.logout()
    this.stepProcess = 'INIT'
    this.createForm()
    this.codeSent = false
    this.isPhoneVerified = false
    this.timer = 0;
  }

  continueProcess() {
    this.authService.updateUserLocalData({token: this.token})
    this.stepProcess = 'PROCESS'
    this.getFlow()
  }

  startNewProcess() {
    this.isPhoneVerified = false;
    this.authService.logout()
    this.entity.reset();
    this.codeSent = false;
    this.timer = 0;
    this.stepProcess = 'INIT';
  }


  getFlow() {
    this.flowService.getFlow().subscribe(r => {
      console.log(r)
      if(!r.error) this.data = r.data
    })
  }

  retryFlow() {
    this.getFlow()
  }

  showScreen(stage: IFlow) {
    console.log(stage)
    console.log("data", this.data)
    this.screenVerificationList = false
    this.backRoute = '/verify-documents'
    this.titleSection = stage.properties.title
    this.currentScreenType = stage.properties.type
    this.currentScreenData = stage
  }

  showVerificationScreen (retryFlow: false) {
    this.screenVerificationList = true
    this.backRoute = '/'
    this.titleSection = 'Verifica tu información'
    if(window['ReactNativeWebView' as unknown as any]) window['ReactNativeWebView' as unknown as any].postMessage(JSON.stringify({type: 'CLOSE'}))
    if (retryFlow) this.getFlow()
  }
}
